import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3ed4406f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Welcome to the NavaRoute", -1))
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Driver Alerts", -1))
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Time Off / PTO", -1))
const _hoisted_7 = { class: "card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School Closings", -1))
const _hoisted_9 = { class: "card" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Company Notifications", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driverAlerts, (alert) => {
          return (_openBlock(), _createElementBlock("li", {
            key: alert.id
          }, [
            _createTextVNode(_toDisplayString(alert.message) + " - ", 1),
            _createElementVNode("strong", null, _toDisplayString(alert.date), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeOffPTO, (pto) => {
          return (_openBlock(), _createElementBlock("li", {
            key: pto.id
          }, [
            _createTextVNode(_toDisplayString(pto.name) + " requested " + _toDisplayString(pto.days) + " days off starting from ", 1),
            _createElementVNode("strong", null, _toDisplayString(pto.startDate), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolClosings, (closing) => {
          return (_openBlock(), _createElementBlock("li", {
            key: closing.id
          }, [
            _createTextVNode(_toDisplayString(closing.schoolName) + " - Closed on ", 1),
            _createElementVNode("strong", null, _toDisplayString(closing.date), 1),
            _createTextVNode(" due to " + _toDisplayString(closing.reason), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyNotifications, (notification) => {
          return (_openBlock(), _createElementBlock("li", {
            key: notification.id
          }, [
            _createTextVNode(_toDisplayString(notification.message) + " - ", 1),
            _createElementVNode("strong", null, _toDisplayString(notification.date), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}